// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import AnimateHeight from 'react-animate-height'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { FormFieldLayout } from '../../generic'

export default function ZoneField({
  errors,
  formKey,
  onChange,
  features,
  values,
  zones,
  ...props
}) {
  if (!features || !zones) return null

  const error = get(errors, formKey)

  let component
  if (!features.features?.zones?.enabled) {
    component = (
      <Link to={`/pro-advert`}>
        Pro! Feature <span className="octicon octicon-chevron-right" />
      </Link>
    )
  } else if (!zones.length) {
    component = (
      <Link to={`/settings/zones`}>
        Add Zones <span className="octicon octicon-chevron-right" />
      </Link>
    )
  } else {
    const unassigned = { id: 'Unassigned', name: 'Unassigned' }
    zones = [...zones, unassigned]
    component = (
      <Select
        classNamePrefix={error ? 'lmc-select-error' : 'lmc-select'}
        getOptionLabel={({ name }) => name}
        getOptionValue={({ id }) => id}
        options={zones}
        onChange={({ id }) =>
          onChange({
            key: formKey,
            value: id
          })
        }
        value={
          values.zone
            ? zones.filter(({ id }) => id === values.zone)
            : { id: 'Unassigned', name: 'Unassigned' }
        }
      />
    )
  }

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      {component}
      <AnimateHeight
        animateOpacity={true}
        duration={200}
        height={error ? 'auto' : 0}
      >
        <div style={styles.error}>{error}</div>
      </AnimateHeight>
    </FormFieldLayout>
  )
}

const styles = {
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 5
  }
}

ZoneField.propTypes = {
  features: PropTypes.object,
  zones: PropTypes.array
}
